import type { App } from 'vue';
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { config } from '@fortawesome/fontawesome-svg-core';

// 1. SVG-core styling (Nodig voor de iconen in je componenten)
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

// 2. Webfont-styling (Nodig voor de icoontjes in Vuetify)
import '@fortawesome/fontawesome-pro-webfonts/css/fontawesome.css';
import '@fortawesome/fontawesome-pro-webfonts/css/fa-light.css'; // Voor 'fal' (Vuetify)
import '@fortawesome/fontawesome-pro-webfonts/css/fa-regular.css'; // Voor 'far'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    FontAwesomeIcon: typeof FontAwesomeIcon;
    FontAwesomeLayers: typeof FontAwesomeLayers;
    FontAwesomeLayersText: typeof FontAwesomeLayersText;
  }
}

export default {
  install(app: App<Element>) {
    app.component('FontAwesomeIcon', FontAwesomeIcon);
    app.component('FontAwesomeLayers', FontAwesomeLayers);
    app.component('FontAwesomeLayersText', FontAwesomeLayersText);
  },
};
